export var AppRole;
(function (AppRole) {
    AppRole["Executive"] = "EscalationHub.Executive";
    AppRole["QALoB"] = "EscalationHub.QALoB";
    AppRole["CLoB"] = "EscalationHub.CLoB";
    //add other roles here
})(AppRole || (AppRole = {}));
